import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { IssueDetailModel } from 'src/app/shared/models/issue.model';
import { IssueService } from 'src/app/shared/services/issue.service';

@Component({
  selector: 'app-opened-issue',
  templateUrl: './opened-issue.component.html',
  styleUrls: ['./opened-issue.component.css']
})
export class OpenedIssueComponent implements OnInit {

  
  thisData : MatTableDataSource<any>;
  displayColumn : string[]= ['issue', 'track'];
  @ViewChild(MatSort, { static: false }) sort : MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator : MatPaginator;
  searchKey : string;
  
  constructor(private service : IssueService) { 

      console.log("IssueListComponent ");

    }

  ngOnInit() {
    this.refreshList();
  }

 
  refreshList()
  {
  
      this.service.getOpenedIssueList(5).subscribe(
        res => {
          let array = res as IssueDetailModel[];
          this.thisData = new MatTableDataSource(array);
          this.thisData.sort = this.sort;
          this.thisData.paginator = this.paginator;
         
        },
        err =>{
          console.log(err);
        }
      );
   
  }

}
